// Function to derive a display name from an email address
export const deriveDisplayNameFromEmail = (
  emailAddress: string,
  projectDescription: string,
): string => {
  const localPart = emailAddress.split("@")[0].toLowerCase();

  // Standard mailbox names with suggested display names
  const standardMailBoxes: Record<string, string> = {
    info: projectDescription,
    contact: projectDescription,
    kontakt: projectDescription,
    website: projectDescription,
    team: projectDescription,
    hello: projectDescription,
    hej: projectDescription,
    hi: projectDescription,
    hallo: projectDescription,
    moin: projectDescription,
    email: projectDescription,
    mail: projectDescription,
    office: projectDescription,
    buero: projectDescription,
    post: projectDescription,
    praxis: projectDescription,
    catchall: projectDescription,
    noreply: projectDescription,
    "no-reply": projectDescription,
    test: `${projectDescription} - Testpostfach`,
    support: `${projectDescription} - Support`,
    ticket: `${projectDescription} - Support`,
    tickets: `${projectDescription} - Support`,
    vertrieb: `${projectDescription} - Vertrieb`,
    sales: `${projectDescription} - Vertrieb`,
    anfrage: `${projectDescription} - Vertrieb`,
    bestellung: `${projectDescription} - Vertrieb`,
    booking: `${projectDescription} - Vertrieb`,
    shop: `${projectDescription} - Shop`,
    einkauf: `${projectDescription} - Einkauf`,
    amazon: `${projectDescription} - Einkauf`,
    buchhaltung: `${projectDescription} - Buchhaltung`,
    rechnung: `${projectDescription} - Buchhaltung`,
    rechnungen: `${projectDescription} - Buchhaltung`,
    invoice: `${projectDescription} - Buchhaltung`,
    paypal: `${projectDescription} - Buchhaltung`,
    invoices: `${projectDescription} - Buchhaltung`,
    personal: `${projectDescription} - Personal/HR`,
    jobs: `${projectDescription} - Personal/HR`,
    job: `${projectDescription} - Personal/HR`,
    bewerbung: `${projectDescription} - Personal/HR`,
    hr: `${projectDescription} - Personal/HR`,
    presse: `${projectDescription} - Presse/PR`,
    pr: `${projectDescription} - Presse/PR`,
    kreation: `${projectDescription} - Kreation`,
    marketing: `${projectDescription} - Marketing`,
    newsletter: `${projectDescription} - Newsletter`,
    news: `${projectDescription} - Newsletter`,
    social: `${projectDescription} - Social Media-Team`,
    facebook: `${projectDescription} - Social Media-Team`,
    datenschutz: `${projectDescription} - Datenschutz-Team`,
    admin: `${projectDescription} - Admin`,
    service: `${projectDescription} - Service`,
    webmaster: `${projectDescription} - Webmaster`,
    postmaster: `${projectDescription} - Postmaster`,
    technik: `${projectDescription} - Technik`,
    domainservice: `${projectDescription} - Domainservice`,
    archiv: `${projectDescription} - Archiv`,
    vorstand: `${projectDescription} - Vorstand`,
    sekretariat: `${projectDescription} - Sekretariat`,
    verwaltung: `${projectDescription} - Verwaltung`,
    kassenwart: `${projectDescription} - Kassenwart`,
  };

  // Check if it's a standard mailbox
  if (standardMailBoxes[localPart]) {
    return standardMailBoxes[localPart];
  }

  // Try to derive a name from the local part
  // Replace common separators with spaces and capitalize words
  const displayName = localPart
    .replace(/[._-]/g, " ")
    .split(" ")
    .map((word) => {
      // If word is only one character, add a dot (abbreviation)
      if (word.length === 1) {
        return word.toUpperCase() + ".";
      }
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(" ");

  // If it looks like a name (contains spaces after processing), return it
  if (displayName.includes(" ")) {
    return displayName;
  }

  // If it's a single word, capitalize it
  // Check if it's a single character (abbreviation)
  // duplicate?
  if (displayName.length === 1) {
    return displayName.toUpperCase() + ".";
  }

  return displayName;
};
